module.exports = __webpack_public_path__ + "fonts/6f45b3a8e301bbf1320e908a45d4bf85.svg";